module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-03-fc33a3c137869ca4196c564ce0534ba0.jpg";